import React from 'react';
import { Link } from 'react-router-dom';
import './VentureTrailers.css';

const VentureTrailers: React.FC = () => {
  const trailerTypes = [
    {
      title: "Aluminum Trailers",
      description: "Lightweight, durable trailers perfect for freshwater use with superior corrosion resistance.",
      image: "/images/trailers/aluminum-tandem-axle-bunk.jpg",
      link: "/trailers/aluminum"
    },
    {
      title: "Bunk Trailers", 
      description: "Superior boat support with carpeted bunks for hull protection and stability.",
      image: "/images/trailers/bunk-galvanized-tandem-axle.jpg",
      link: "/trailers/bunk"
    },
    {
      title: "Roller Trailers",
      description: "Easy loading and launching with precision roller systems for effortless boat handling.",
      image: "/images/trailers/roller-galvanized-tandem-axle.jpg", 
      link: "/trailers/roller"
    },
    {
      title: "Galvanized Trailers",
      description: "Maximum corrosion protection with hot-dip galvanized construction for saltwater use.",
      image: "/images/trailers/galvanized-tandem-axle-bunk.jpg",
      link: "/trailers/galvanized"
    },
    {
      title: "Pontoon/Tritoon",
      description: "Specialized trailers designed for pontoon and tritoon boats with adjustable bunks.",
      image: "/images/trailers/pontoon-galvanized-tandem-axle.jpg",
      link: "/trailers/pontoon"
    },
    {
      title: "PWC Trailers",
      description: "Compact trailers built specifically for personal watercraft and jet skis.",
      image: "/images/trailers/pwc-galvanized-single-axle.jpg",
      link: "/trailers/pwc"
    },
    {
      title: "Skiff Trailers",
      description: "Lightweight trailers perfect for jon boats, skiffs, and small fishing boats.",
      image: "/images/trailers/aluminum-single-axle-skiff.jpg",
      link: "/trailers/skiff"
    },
    {
      title: "Commander Trailers",
      description: "Heavy-duty trailers engineered for large boats and demanding marine applications.",
      image: "/images/trailers/commander-tandem-axle.jpg",
      link: "/trailers/commander"
    }
  ];

  return (
    <section className="venture-trailers py-5" id="trailers">
      <div className="container">
        <div className="text-center mb-4">
          <div className="venture-logo-section">
            <img src="/images/logos/venture-logo.png" alt="Venture Trailers" className="venture-logo" />
            <p className="venture-tagline">Authorized Venture Trailers Dealer</p>
          </div>
          <h2>Venture Trailer Collection</h2>
          <p>Explore our complete range of premium boat trailers designed for every vessel type</p>
        </div>
        <div className="trailers-grid">
          {trailerTypes.map((trailer, index) => (
            <Link key={index} to={trailer.link} className="trailer-card">
              <div className="trailer-image">
                <img src={trailer.image} alt={trailer.title} />
              </div>
              <div className="trailer-content">
                <h3>{trailer.title}</h3>
                <p>{trailer.description}</p>
                <div className="card-cta">
                  <span>View Details →</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VentureTrailers;